import { NgxsModule, Store } from '@ngxs/store';

import { NgModule } from '@angular/core';
import { PreautorisationExperimenteService as PreautorisationDsdService } from './experimente/services/preautorisation-experimente/preautorisation-experimente.service';
import { PreautorisationState as PreautorisationExperimenteState } from '../tool-preautorisation/experimente/state/preautorisation.state';
import { ToolPreautorisationService } from './tool-preautorisation.service';

@NgModule({
  imports: [NgxsModule.forFeature([PreautorisationExperimenteState])],
  providers: [
    {
      provide: ToolPreautorisationService,
      useFactory: toolCapaciteServiceFactory,
      deps: [Store]
    }
  ]
})
export class ToolPreautorisationStateModule {}

function toolCapaciteServiceFactory(store: Store) {
  return new PreautorisationDsdService(store);
}
